/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * AlignObjectsCenterIcon
 */
export default class AlignObjectsCenterIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12 18.911a1 1 0 01.993.884l.007.116v1.048a1 1 0 01-1.993.117L11 20.959v-1.048a1 1 0 011-1zM15.5 14a1 1 0 011 1v2a1 1 0 01-1 1h-7a1 1 0 01-1-1v-2a1 1 0 011-1h7zm2-8a2 2 0 012 2v3a2 2 0 01-2 2h-11a2 2 0 01-2-2V8a2 2 0 012-2zm0 2h-11v3h11V8zM12 1.911a1 1 0 01.993.884L13 2.91V3.96a1 1 0 01-1.993.117L11 3.959V2.911a1 1 0 011-1z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

